import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../ServicePage.css';

function VoipAsterisk() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Centralini VoIP Asterisk</h1>
                    <p className="service-description">
                        Assistenza specializzata su centralini Asterisk, integrazione con gestionali
                        e soluzioni VoIP complete per la tua azienda.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Cos'è Asterisk?</h2>
                                <p className="section-description">
                                    Asterisk è il sistema telefonico open source più utilizzato al mondo per
                                    creare centralini VoIP professionali. Offre funzionalità avanzate come
                                    code di chiamata, IVR, recording e integrazioni con sistemi aziendali.
                                </p>
                                
                                <div className="asterisk-features">
                                    <Row>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-phone text-primary"></i>
                                                <strong>Centralino Completo</strong>
                                                <p>Sistema telefonico avanzato con tutte le funzionalità professionali</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-users text-primary"></i>
                                                <strong>Code di Chiamata</strong>
                                                <p>Gestione avanzata delle chiamate in entrata con distribuzione intelligente</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-microphone text-primary"></i>
                                                <strong>IVR Personalizzati</strong>
                                                <p>Menu vocali interattivi per guidare i clienti verso il reparto giusto</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-chart-bar text-primary"></i>
                                                <strong>Report Avanzati</strong>
                                                <p>Statistiche dettagliate su chiamate, performance e utilizzo del sistema</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card highlight-card">
                            <Card.Body>
                                <h2 className="section-title">I Nostri Servizi Asterisk</h2>
                                
                                <Row>
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-cogs text-primary"></i>
                                            </div>
                                            <h4>Installazione e Configurazione</h4>
                                            <p>
                                                Setup completo di centralini Asterisk con configurazione
                                                ottimizzata per le esigenze specifiche della tua azienda.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-link text-primary"></i>
                                            </div>
                                            <h4>Integrazione con Gestionali</h4>
                                            <p>
                                                Connessione del centralino con CRM, ERP e sistemi aziendali
                                                per automatizzare i flussi di lavoro.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-headset text-primary"></i>
                                            </div>
                                            <h4>Assistenza Tecnica</h4>
                                            <p>
                                                Supporto specializzato per manutenzione, troubleshooting
                                                e ottimizzazione dei sistemi Asterisk.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-cloud text-primary"></i>
                                            </div>
                                            <h4>Soluzioni Cloud</h4>
                                            <p>
                                                Centralini VoIP completamente in cloud senza necessità
                                                di hardware dedicato in sede.
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Perché Scegliere i Nostri Servizi VoIP?</h2>
                                
                                <Row>
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-certificate text-primary"></i>
                                            </div>
                                            <h5>Esperienza Comprovata</h5>
                                            <p>Anni di esperienza nella gestione di sistemi VoIP Asterisk</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-tools text-primary"></i>
                                            </div>
                                            <h5>Assistenza Specializzata</h5>
                                            <p>Supporto tecnico dedicato e personalizzato per ogni esigenza</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-clock text-primary"></i>
                                            </div>
                                            <h5>Disponibilità Garantita</h5>
                                            <p>Supporto durante orari lavorativi e interventi urgenti su richiesta</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card className="service-card cta-card">
                            <Card.Body className="text-center">
                                <h3>Hai Bisogno di Assistenza VoIP?</h3>
                                <p className="mb-4">
                                    Contattaci per una consulenza gratuita e scopri come possiamo
                                    ottimizzare il tuo sistema telefonico Asterisk.
                                </p>
                                <div className="mb-3">
                                    <a
                                        href="https://www.swebsolution.it"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-primary btn-lg me-3"
                                    >
                                        Visita swebsolution.it
                                    </a>
                                    <a href="#contact" className="btn btn-primary btn-lg">
                                        Richiedi Assistenza
                                    </a>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default VoipAsterisk;